import type { CriticalAiResult } from '@sr-test-wizard/shared';
import { api } from './api';

/**
 * Client for the `/api/runs/:id/critical-ai` route module (AI Critical-File
 * Nominator, Phase 3 helper). Nomination is fire-and-forget - the card reflects
 * progress from the `critical-ai-progress` WS stream and re-fetches the result
 * on completion.
 */
export const criticalAiApi = {
  get: (runId: string) =>
    api.get<{ result: CriticalAiResult | null }>(`/api/runs/${runId}/critical-ai`),
  nominate: (runId: string) =>
    api.post<{ started: boolean; alreadyRunning?: boolean }>(
      `/api/runs/${runId}/critical-ai/nominate`,
    ),
};
